import "./style";
import "milligram/dist/milligram.min.css";
import App from "./components/app";

export default App;



// WEBPACK FOOTER //
// ./index.js